/** KAN-718: направление письма: исходящее (от нас) или входящее (от клиента). */
import { ArrowDownLeft, ArrowUpRight } from 'lucide-react';
import { EMAIL_DIRECTION_LABEL } from '@/lib/emailFormat';
import type { EmailDirection } from '@/types/emailMailbox';

export function EmailDirectionIcon({ direction }: { direction: EmailDirection }): JSX.Element {
  const label = EMAIL_DIRECTION_LABEL[direction];
  const Icon = direction === 'out' ? ArrowUpRight : ArrowDownLeft;
  return (
    <span
      title={label}
      aria-label={label}
      data-testid="email-direction"
      data-direction={direction}
      className={`inline-flex h-6 w-6 items-center justify-center rounded-full ${
        direction === 'out' ? 'bg-blue-50 text-blue-700' : 'bg-green-50 text-green-700'
      }`}
    >
      <Icon className="h-3.5 w-3.5" />
    </span>
  );
}
